
// import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";

import { useState, useEffect } from 'react';
import { URL } from '../../Redux/common/url';


const FaqSection = () => {

     const [productLists, setProductListt] = useState([]);
    
      useEffect(() => {
        fetchProductList();
      }, []);
    
      const fetchProductList = async () => {
        try {
          const response = await fetch(
            `${URL.API_BASE_URL}/publicApi/workListPublic`
          );
          if (response.ok) {
            const data = await response.json();
            setProductListt(data?.works); // Store the sliders in state
          }
          const data = await response.json();
          console.log(data);
        } catch (error) {
          console.error("Fetch error:", error);
        }
      };
    const [openIndex, setOpenIndex] = useState(0);

    const faqs = [
        {
            question: "How do evaporative air coolers work?",
            answer:
                "They use the natural process of water evaporation to cool air, delivering a continuous supply of fresh, cool air while consuming much less power than traditional air conditioners.",
        },
        {
            question: "Are your cooling systems suitable for large industrial spaces?",
            answer:
                "Yes! Our ductable air coolers and industrial exhaust fans are specifically designed for factories, warehouses, workshops, and other large commercial or institutional spaces.",
        },
        {
            question: "What are the maintenance requirements?",
            answer:
                "Our systems are designed for low maintenance. Regular cleaning of filters and periodic checks ensure long-lasting, trouble-free performance.",
        },
        {
            question: "How energy-efficient are your solutions?",
            answer:
                "Our air coolers can save up to 80% energy compared to traditional AC systems. Exhaust fans also feature energy-efficient motors for reduced power consumption.",
        },
        {
            question: "Do you offer installation and after-sales support?",
            answer:
                "Yes! We provide professional installation and reliable after-sales service to ensure your systems run smoothly and efficiently.",
        },
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div style={{ backgroundColor: "#eaf2f7" }} className="py-5 container-fluid px-0">
            < div className="container-fluid my-2">
                <div className="row ">
                    {/* Heading */}
                    <div className="col-md-6">
                        <p className="text-danger fw-bold small mb-1">FAQ ---------</p>
                        <h2 className="fw-bold mb-4">Frequently Asked Questions</h2>
                                            <div>
      <img
        src="https://img.freepik.com/premium-vector/faq-banner-concept-questionnaire-giving-information-users-website-customers-with-cartoon-people-vector-illustration-isolated-white-background_181313-1312.jpg"
        alt="FAQ Banner"
        className="faq-banner"
      />
    </div>
                    </div>
                    {/* Accordion */}
                    <div className="accordion col-md-6" id="faqAccordion">
                       {productLists && productLists.length > 0 ? (
            productLists.map((item, index) => (   
                            <div
                                className="accordion-item mb-3 border-0 shadow-sm rounded"
                                key={index}
                            >
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button fw-semibold ${openIndex === index ? "bg-danger text-white" : "bg-white"
                                            }`}
                                        type="button"
                                        onClick={() => toggleFAQ(index)}
                                    >
                                        <i
                                            className={`me-2 fas ${openIndex === index ? "fa-circle-chevron-up" : "fa-circle-chevron-down"
                                                }`}
                                        ></i>
                                        {item.title}
                                    </button>
                                </h2>
                                {openIndex === index && (
                                    <div className="accordion-body text-muted ">{item.short_description}</div>
                                )}
                            </div>
                                                         
       ))
            ) : (
            <p>Loading...</p>
            )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FaqSection;
